import { DashboardPerformanceChart } from '../components/DashboardPerformanceChart';
import { dashboardReportExplorerSearch } from '../dashboardReporting';
import { DashboardWidgetType } from '../model';
import { serializePerformanceAnalyzerRouteSearch } from '../../reporting/performanceAnalyzer/performanceAnalyzerRouteSearch';
import type { DashboardWidgetRendererProps } from './widgetRenderers.types';

export function ChartRenderer({ widget, query, range }: DashboardWidgetRendererProps) {
  if (widget.type !== DashboardWidgetType.PerformanceChart) return null;
  return (
    <DashboardPerformanceChart
      overview={query?.data}
      metrics={widget.metrics}
      defaultVisibleMetrics={widget.defaultVisibleMetrics}
      range={range}
      loading={Boolean(query?.isLoading)}
      error={Boolean(query?.isError)}
      actions={widget.actions}
      reportingSearch={dashboardReportExplorerSearch(widget, range)}
      performanceAnalyzerSearch={serializePerformanceAnalyzerRouteSearch(range)}
    />
  );
}
